import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React, { Fragment } from 'react';
import { TextField, MenuItem } from '@material-ui/core';
import DataItem from './DataItem';
/**
 * @extends {React.Component<import('./types').DataTreeSelectProps>}
 */

export var DataTreeSelect =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DataTreeSelect, _React$Component);

  function DataTreeSelect() {
    _classCallCheck(this, DataTreeSelect);

    return _possibleConstructorReturn(this, _getPrototypeOf(DataTreeSelect).apply(this, arguments));
  }

  _createClass(DataTreeSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          isLoading = _this$props.isLoading,
          hasError = _this$props.hasError,
          items = _this$props.items;
      return React.createElement(Fragment, null, React.createElement(TextField, {
        select: true,
        fullWidth: true,
        disabled: isLoading || hasError,
        value: isLoading ? 'loading' : value,
        onChange: onChange,
        error: hasError,
        helperText: hasError && 'Could not load the data model, the file is missing or invalid.'
      }, isLoading && React.createElement(MenuItem, {
        value: "loading"
      }, React.createElement("div", {
        style: {
          marginTop: 2,
          marginBottom: 2
        }
      }, "Loading...")), items.map(function (item) {
        return React.createElement(MenuItem, {
          key: item.xpath,
          value: item.xpath,
          style: {
            paddingLeft: 16 + item.indent * 2 * 8
          }
        }, React.createElement(DataItem, item));
      })));
    }
  }]);

  return DataTreeSelect;
}(React.Component);
export default DataTreeSelect;